import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IReturnPersonalizationBatchDataTableRowFormMeta {
  effectiveDate: FormInputMeta,
  batchNumber: FormInputMeta,
  PAN: FormInputMeta,
  operationType: FormInputMeta,

  schema: any,
}

const ReturnPersonalizationBatchDataTableRowFormMeta = {} as IReturnPersonalizationBatchDataTableRowFormMeta;

ReturnPersonalizationBatchDataTableRowFormMeta.effectiveDate = {
  name: "effectiveDate",
  type: "date",
  label: "Date",
  placeholder: "",
  validation: yup.date().required("Ce champ est requis")
};

ReturnPersonalizationBatchDataTableRowFormMeta.batchNumber = {
  name: 'batchNumber',
  type: 'text',
  label: 'Numero de Lot',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};

ReturnPersonalizationBatchDataTableRowFormMeta.PAN = commonFormMeta.PAN;

ReturnPersonalizationBatchDataTableRowFormMeta.operationType = {
  name: 'operationType',
  type: 'text',
  label: 'Type Operation',
  placeholder: '',
  validation: yup.string().required("Ce champ est requis"),
};


ReturnPersonalizationBatchDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(ReturnPersonalizationBatchDataTableRowFormMeta));

export default ReturnPersonalizationBatchDataTableRowFormMeta;